import React, { Component, Fragment } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
} from "../../../common/component/Index";
import i18n from "../../../../../constants/initLng";
import { PATHS, UPLOAD_DIRECTORY } from "../../../../../constants/Define";
import { message } from 'antd';
import { isEqual, get, find } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import PopularPlace from '../../../../../models/PopularPlace';
import Wrapper from './../../../common/component/Wrapper';
import Button from './../../../common/component/Button';
import Radio from './../../../common/component/Radio';
import PlaceDetail from './PlaceDetail';

import './PopularPlaceDetail.less';

let permisionActions = [];
const defaultState = {
    action: "CREATE",
    isSubmit: false,
    isGetItem: false,
    validation: {},
};

export default class PopularPlaceDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            popularPlace: this.props.popularPlaceState.detail.popularPlace,
            uploadFiles: [],
        };
    }

    componentDidMount() {
        this.initDetail()
    }

    componentWillUnmount() {
        this.props.setPopularPlaceDetail(new PopularPlace())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.popularPlaceState.detail.popularPlace && !isEqual(nextProps.popularPlaceState.detail.popularPlace, this.props.popularPlaceState.detail.popularPlace)) {
            this.setState({
                popularPlace: nextProps.popularPlaceState.detail.popularPlace,
                action: nextProps.popularPlaceState.detail.popularPlace.id ? 'UPDATE' : this.state.action
            });
        }
        if (nextProps.uploadState.file && !isEqual(nextProps.uploadState.file, this.props.uploadState.file)) {
            this.processUploadedFiles(nextProps.uploadState.file);
        }
    }

    render() {
        const { t, popularPlaceState, uploadState } = this.props;
        const { isFetching } = popularPlaceState;
        const { action, isSubmit, isGetItem, validation, popularPlace } = this.state;
        return (
            <LoadingComponent spinning={isFetching || isSubmit}>
                <PageListComponent className="hotel-detail-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'popularPlaces'}
                        titleHeader={action === "CREATE"
                            ? Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.popularPlace.title')}`).toLowerCase())
                            : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.popularPlace.title')}`.toLowerCase()))
                        }

                    />
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        isSubmit={isSubmit}
                        action={action}
                        isGetItem={isGetItem}
                        onClickBack={this.onClickBack}
                        activeComponent={'SWITCH'}
                        onChangeActive={e => this.onChangeDetail(e.name, e.value)}
                        titleActiveComponent={popularPlace.isActive ? t(`item.popularPlace.active`) : t(`item.popularPlace.deactive`)}
                        submitButtonRight={true}
                        statusActiveName={`isActive`}
                        statusActive={popularPlace.isActive}
                    >
                        <Wrapper className='col-md-12 p-0 m-0'>
                            <PlaceDetail place={popularPlace}
                                uploading={uploadState.isFetchingMultiple}
                                disabled={!popularPlace.isActive}
                                validation={validation}
                                onUploadImage={this.onUploadImages}
                                onRemoveImage={this.removeImages}
                                onChange={this.onChangeDetail} />
                        </Wrapper>
                    </FormActionComponent>
                </PageListComponent>
            </LoadingComponent>
        );
    }

    initDetail() {
        const { match, popularPlaceState } = this.props;
        let popularPlace = this.state.popularPlace;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({ action: "UPDATE" });
            popularPlace = find(popularPlaceState.dataList, item => item.id === id) || popularPlace;
            if(popularPlace) this.setState({popularPlace});
            this.props.getPopularPlaceDetail(id);
        }
    }

    onChangeDetail = (fieldName, value) => {
        const popularPlace = this.state.popularPlace;
        popularPlace[fieldName] = value;
        this.setState({ popularPlace });
    };

    onSubmit = (e) => {
        e.preventDefault();
        if (this.validate()) {
            this.updateDetail()
        }
    };

    onClickBack = () => {
        this.props.history.push(PATHS.POPULAR_PLACE.LIST.path);
    }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.popularPlace.name`)),
                numberOfVacancies: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.popularPlace.numberOfVacancies`)),
                averagePrice: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.popularPlace.averagePrice`)),
            }
        };
        let valueValidate = {};
        const result = Func.multipleValidate(this.state.popularPlace, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    updateDetail() {
        const { popularPlace, action } = this.state;
        const actionFunction = action === 'CREATE' ? this.props.createPopularPlace : this.props.updatePopularPlace;
        actionFunction(popularPlace);
    }

    processUploadedFiles(fileObj) {
        let uploadFiles = this.state.uploadFiles;
        const popularPlace = this.state.popularPlace;
        popularPlace.setImage(get(fileObj, 'data.fileUrl'), get(fileObj, 'data.fileName'))
        this.setState({ popularPlace, uploadFiles });
    }

    onUploadImages = (file) => {
        let fileData = file.target.files;
        let uploadFiles = this.state.uploadFiles;
        if (fileData.length > 6) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 6));
            return false;
        } else if ((uploadFiles.length + fileData.length) > 6) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 6));
            return false;
        }
        let imageValidation = ['image/jpeg', 'image/jpg', 'image/png'];
        Object.keys(fileData).map((i) => {
            if (imageValidation.includes(fileData[i].type)) {
                this.props.onUploadFile({ file: fileData[i], directory: UPLOAD_DIRECTORY.POPULAR_PLACE, isFile: 2 })
            } else {
                message.error(i18n.t('validation.image'))
            }
        })
    }

    removeImages = (i, k) => {
        if (!i) return;
        const popularPlace = this.state.popularPlace;
        popularPlace.removeImage(i)
        this.setState({ popularPlace });
    };

}
